<div class="head-title mb-2">
  <!-- Lưu ý -->
  <p class="title-explain">* {{ 'keo_tha_hinh_anh_de_thay_doi_thu_tu' | translate }}</p>

  <!-- Nếu ảnh chứa id_subproject thì đã là ảnh trên server rồi nên sẽ ẩn -->
  <button *ngIf="hasSomeImgNotIncludeIdSubproject()" class="upload-background-image" (click)="isShowConfirmPopup = true">
    {{'chuyen_anh_len_server' | translate}}
  </button>
</div>

<!-- Phần chọn option và nguồn để tải ảnh lên -->
<div class="d-flex" style="gap: 16px">
  <!-- Phần chọn sử dụng hình ảnh thêm là riêng cho 1 thiết bị hay dùng chung cho 5 thiết bị -->
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>{{'kieu_hien_thi_anh' | translate}}</mat-label>
    <mat-select disableRipple [(ngModel)]="objectChoosing.setups.upload_image.display"
      (ngModelChange)="changeImgType()">
      <mat-option value="shared">{{'anh_dung_chung_cho_tung_thiet_bi' | translate}}</mat-option>
      <mat-option value="individual">{{'anh_dung_rieng_cho_tung_thiet_bi' | translate}}</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Phần chọn nguồn ảnh -->
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>{{'nguon_hinh_anh_hien_thi_len' | translate}}</mat-label>
    <mat-select disableRipple [(ngModel)]="objectChoosing.setups.upload_image.source" (ngModelChange)="updateSetups()">
      <mat-option value="device">{{'tu_thiet_bi' | translate}}</mat-option>
      <mat-option value="library">{{'tu_thu_vien' | translate}}</mat-option>
      <mat-option value="url">{{'duong_dan_hinh_anh' | translate}}</mat-option>
      <mat-option value="free_img">{{'kho_anh_dung_chung' | translate}}</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Phần lựa chọn nén ảnh -->
  <mat-form-field *ngIf="objectChoosing.setups.upload_image.source == 'device'" appearance="fill" class="config-img w-100"
   >
    <mat-label>{{'nen_anh_tai_len' | translate}}</mat-label>
    <mat-select disableRipple [(ngModel)]="objectChoosing.setups.upload_image.compress_type"
      (ngModelChange)="updateSetups()">
      <mat-option [value]="'no-compress'">{{'khong_nen_anh_sau_khi_tai_len' | translate}}</mat-option>
      <mat-option [value]="'compress-screen'">{{'nen_anh_theo_ti_le_man_hinh_hien_thi' | translate}}</mat-option>
      <mat-option [value]="'compress-frame'">{{'nen_anh_theo_ti_le_khung_hien_thi_anh' | translate}}</mat-option>
      <mat-option [value]="'custom'">{{'nen_anh_theo_kich_thuoc_tu_chon' | translate}}</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Phần chọn kích thước nén ảnh nếu lựa chọn nén theo kích thước tự chọn -->
  <mat-form-field
    *ngIf="objectChoosing.setups.upload_image.source == 'device' &&  objectChoosing.setups.upload_image.compress_type == 'custom'"
    class="mr-4">
    <mat-label>{{'chieu_rong' | translate}}</mat-label>
    <input matInput placeholder="{{'chieu_rong' | translate}}" [(ngModel)]="compressWidth">
  </mat-form-field>

  <mat-form-field
    *ngIf="objectChoosing.setups.upload_image.source == 'device' &&  objectChoosing.setups.upload_image.compress_type == 'custom'">
    <mat-label>{{'chieu_cao' | translate}}</mat-label>
    <input matInput placeholder="{{'chieu_cao' | translate}}" [(ngModel)]="compressHeight">
  </mat-form-field>
</div>

<!-- Phần modal chuyển ảnh lên server -->
<nz-modal nzTitle="{{ 'chuyen_anh_len_server' | translate}}" [(nzVisible)]="isShowConfirmPopup" [nzContent]="modalContent"
  (nzOnCancel)="isShowConfirmPopup = false;" (nzOnOk)="handleOkConfirm()" [nzFooter]="modalFooter">
  <ng-template #modalContent>
    <p>{{'nen_anh_tai_len' | translate}}</p>
    <nz-select style="margin-bottom: 15px" [(ngModel)]="objectChoosing.setups.upload_image.compress_type"  (ngModelChange)="updateSetups()"
      nzPlaceHolder="{{'nen_anh_tai_len' | translate}}" nzAllowClear>
      <nz-option [nzValue]="'no-compress'" nzLabel="{{'khong_nen_anh_sau_khi_tai_len' | translate}}"></nz-option>
      <nz-option [nzValue]="'compress-screen'" nzLabel="{{'nen_anh_theo_ti_le_man_hinh_hien_thi' | translate}}"></nz-option>
      <nz-option [nzValue]="'compress-frame'" nzLabel="{{'nen_anh_theo_ti_le_khung_hien_thi_anh' | translate}}"></nz-option>
      <nz-option [nzValue]="'custom'" nzLabel="{{'nen_anh_theo_kich_thuoc_tu_chon' | translate}}"></nz-option>
    </nz-select>

    <mat-form-field *ngIf="objectChoosing.setups.upload_image.compress_type == 'custom'" class="mr-4">
      <mat-label>{{'chieu_rong' | translate}}</mat-label>
      <input matInput placeholder="{{'chieu_rong' | translate}}" [(ngModel)]="compressWidth">
    </mat-form-field>

    <mat-form-field *ngIf="objectChoosing.setups.upload_image.compress_type == 'custom'">
      <mat-label>{{'chieu_cao' | translate}}</mat-label>
      <input matInput placeholder="{{'chieu_cao' | translate}}" [(ngModel)]="compressHeight">
    </mat-form-field>
  </ng-template>
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="isShowConfirmPopup = false;">{{'khong' | translate}}</button>
    <button nz-button nzType="primary" (click)="handleOkConfirm()" [nzLoading]="isConfirmLoading">{{'dong_y' | translate}}</button>
  </ng-template>
</nz-modal>


<!-- Phần danh sách hình ảnh - Có thể nắm kéo thả ngang để thay đổi thứ tự của danh sách hình ảnh -->
<div cdkDropList (cdkDropListDropped)="cdkDropListDropped($event)" class="image-list" [cdkDropListData]="dataImages"
cdkDropListOrientation="horizontal" #scrollList>
  <div *ngFor="let img of dataImages; let i = index" cdkDrag class="image-item my-1" [draggable]="true">
    <div class="image-item__info">
      <div class="image-img__wrapper transparency-grid">
        <img [src]="img" class="image-img" />
      </div>
      <!-- Tên ảnh và icon copy link ảnh -->
      <p class="image-item__info-text" (click)="copyLinkImg(img)"
      nz-tooltip nzTooltipPlacement="bottom"
      nzTooltipTitle="{{'nhan_chuot_de_sao_chep_duong_dan_anh_nay_vao_bo_nho_tam' | translate}}">
        {{ getFileInfo(img).fullFileName }} 
        <mat-icon>content_copy</mat-icon>
      </p>
    </div>
    <div class="gr-btn">
      <div class="gr-btn__status">
        <button *ngIf="!img.includes(id_subproject)" class="gr-btn__button"
        nz-tooltip nzTooltipTitle="{{'anh_chua_duoc_day_len_server_hoac_anh_bi_chan_day_len_server' | translate}}">
          <mat-icon class="gr-btn__button-icon">warning</mat-icon>
        </button>
      </div>
      <div class="gr-btn__action">
        <button class="gr-btn__button" (click)="removeImage(i)">
          <mat-icon class="gr-btn__button-icon">close</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Phần kéo thả ảnh từ bên ngoài vào -->
<div *ngIf="objectChoosing.setups.upload_image.source == 'device'"
class="drop-zone mt-4"
[class.dragging]="dragging"
(drop)="onFileDropped_upload($event)"
(dragover)="onDragOver_upload($event)"
(dragleave)="onDragLeave_upload()">
  <label *ngIf="!previewUrl" for="upload">
    <mat-icon>image</mat-icon>
    <p>{{ 'keo_hinh_anh_vao_day_hoac' | translate }} <span>{{ 'tai_tep_len' | translate }}</span></p>
  </label>

  <div *ngIf="previewUrl" class="preview">
    <img [src]="previewUrl" alt="Preview" />
  </div>

  <div *ngIf="previewUrl" class="button-list">
    <button (click)="openUpload()">
      <mat-icon>{{ iconAddImage[objectChoosing.setups.upload_image.source] }}</mat-icon>
    </button>
    <button (click)="previewUrl = ''">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<!-- Nút thêm ảnh -->
<div *ngIf="objectChoosing.setups.upload_image.source != 'device'"
class="add-image-btn upload-background-image mt-4" (click)="addImage()">
  <p class="add-image-btn_text">{{'them_anh' | translate}}</p>
  <mat-icon class="add-image-btn_icon">{{ iconAddImage[objectChoosing.setups.upload_image.source] }}</mat-icon>

  <div  *ngIf="toggleInputLinkImg">
    <div class="overlay" (click)="closePopover($event)"></div>

    <!-- Phần popup để nhập đường dẫn hình ảnh -->
    <div class="popover">
      <p>{{'duong_dan_anh' | translate}}</p>
      <div class="d-flex align-items-center gap-4">
        <input style="flex: 1 0 100px;" class="input mr-1" type="text" [(ngModel)]="newUrlImage"
        placeholder="{{'nhap_duong_dan_lien_ket' | translate}}">
        <span role="button" class="text-success" (click)="handleChangeUrlImage($event)">{{'ap_dung' | translate}}</span>
      </div>
    </div>
  </div>
</div>

<!-- Input để upload file hình ảnh -->
<input type="file" accept="image/*" (change)="onUpload($event)" id="upload" name="file" hidden />
